<div data-test="employee-navigation">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="accent">
    <a
      mat-tab-link
      [routerLink]="['/employees', employeeId]"
      routerLinkActive
      #detailsLink="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: true }"
      [active]="detailsLink.isActive"
    >
      {{ 'app.employee.navigation.details' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/employees', employeeId, 'relations']"
      routerLinkActive
      #relationsLink="routerLinkActive"
      [active]="relationsLink.isActive"
    >
      {{ 'app.employee.navigation.relations' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
